.section {
  padding-top: calc(var(--section-spacing) * 0.75);
}

.sectionInner {
  position: relative;
}

.compactHeading {
  display: none;
}

.split {
  display: grid;
  width: min(calc(100% - (var(--page-margin) * 2)), var(--container-max));
  min-height: 175svh;
  margin-inline: auto;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  gap: var(--grid-gutter);
}

.visualColumn {
  position: sticky;
  top: 0;
  display: flex;
  height: 100svh;
  grid-column: 1 / span 6;
  align-items: center;
}

.diagramFrame {
  width: 100%;
  margin: 0;
  overflow: hidden;
  border-radius: var(--image-radius);
  background: #0a0a0a;
}

.diagram {
  width: 100%;
  height: auto;
  object-fit: contain;
  transition: transform var(--duration-normal) ease;
}

.narrative {
  display: flex;
  padding-block: 6svh 14svh;
  grid-column: 7 / -1;
  flex-direction: column;
  gap: clamp(6rem, 18svh, 12rem);
}

.heading,
.contentBlock,
.metricCard,
.dimensionBlock {
  width: min(100%, 35rem);
  margin-left: auto;
}

.heading {
  display: flex;
  flex-direction: column;
  gap: var(--space-s);
}

.title {
  max-width: var(--text-width-section);
  font-size: var(--font-size-section);
  font-weight: var(--font-weight-semibold);
  letter-spacing: -0.01em;
  line-height: var(--line-height-section);
  text-wrap: balance;
}

.subtitle {
  color: var(--color-text-primary);
  font-size: var(--font-size-subheading);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-subheading);
}

.body,
.metricCard p,
.dimensionBlock {
  color: var(--color-text-secondary);
  line-height: var(--line-height-body);
}

.metricCard {
  position: relative;
}

.metric {
  display: flex;
  align-items: flex-end;
  color: var(--color-text-primary);
  font-family: var(--font-display);
  font-size: var(--font-size-data);
  font-weight: var(--font-weight-bold);
  letter-spacing: -0.02em;
  line-height: 1;
}

.metricUnit {
  padding-bottom: 0.12em;
  color: var(--color-accent-bronze);
  font-size: 0.42em;
  letter-spacing: 0;
}

.metricCard p {
  margin-top: var(--space-xs);
}

.dimensionBlock {
  padding-top: var(--space-s);
  border-top: 1px solid var(--color-border);
}

.environmentFrame {
  position: relative;
  width: 100vw;
  height: min(75vw, 100svh);
  min-height: 42rem;
  margin: calc(var(--space-xl) * 0.75) 0 0;
  overflow: hidden;
  background: var(--color-background);
}

.environment,
.environmentShade {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.environment {
  object-fit: cover;
  object-position: center center;
  will-change: transform;
}

.environmentShade {
  background: linear-gradient(
    180deg,
    var(--color-background),
    transparent 18% 78%,
    var(--color-background)
  );
  pointer-events: none;
}

.galleryModule,
.videoModule {
  width: min(calc(100% - (var(--page-margin) * 2)), var(--container-max));
  margin-inline: auto;
}

.galleryModule {
  margin-top: calc(var(--space-2xl) * 0.75);
}

.galleryTrack {
  display: flex;
  gap: clamp(1.5rem, 3vw, 3rem);
  overflow-x: auto;
  overscroll-behavior-inline: contain;
  scrollbar-width: none;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  touch-action: pan-x pan-y;
  cursor: grab;
}

.galleryTrack::-webkit-scrollbar {
  display: none;
}

.galleryTrack.isDragging {
  scroll-snap-type: none;
  scroll-behavior: auto;
  cursor: grabbing;
}

.galleryItem {
  flex: 0 0 min(76vw, 67.5rem);
  margin: 0;
  scroll-snap-align: start;
}

.galleryImageButton {
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
  border: 0;
  border-radius: 0;
  background: #080808;
  color: inherit;
  cursor: zoom-in;
}

.galleryImage {
  display: block;
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  transition: transform var(--duration-normal) cubic-bezier(0.22, 1, 0.36, 1);
  user-select: none;
}

.caption {
  display: flex;
  margin-top: var(--space-xs);
  align-items: center;
  justify-content: space-between;
  color: var(--color-text-secondary);
  font-size: var(--font-size-caption);
  font-weight: var(--font-weight-regular);
  letter-spacing: 0.14em;
  line-height: 1.5;
}

.captionText {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  gap: 0.25rem;
  text-align: right;
}

.captionHint {
  color: rgb(255 255 255 / 42%);
  font-size: 0.6875rem;
  font-weight: var(--font-weight-light);
  letter-spacing: 0.08em;
  line-height: 1.4;
}

.progressTrack {
  position: relative;
  height: 1px;
  margin-top: var(--space-m);
  overflow: hidden;
  background: color-mix(in srgb, var(--color-text-primary) 20%, transparent);
}

.progressValue {
  position: absolute;
  inset: 0;
  background: var(--color-text-primary);
  transform-origin: left center;
  transition: transform 120ms linear;
}

.videoModule {
  margin-top: calc(var(--space-xl) * 0.75);
  margin-bottom: calc(var(--space-2xl) * 0.75);
}

.videoFrame {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  background: #050505;
  cursor: zoom-in;
}

.video {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.videoShade {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgb(0 0 0 / 10%), rgb(0 0 0 / 18%));
  pointer-events: none;
  transition: opacity var(--duration-fast) ease;
}

.videoControl {
  position: absolute;
  inset: 0;
  display: grid;
  width: 100%;
  height: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  color: white;
  place-items: center;
  cursor: zoom-in;
}

.videoPlayBadge {
  display: grid;
  width: 4.5rem;
  height: 4.5rem;
  border: 1px solid rgb(255 255 255 / 70%);
  border-radius: 50%;
  background: rgb(5 5 5 / 14%);
  place-items: center;
  backdrop-filter: blur(6px);
  transition:
    border-color var(--duration-fast) ease,
    background-color var(--duration-fast) ease,
    transform var(--duration-fast) ease;
}

.playIcon {
  width: 0;
  height: 0;
  margin-left: 0.22rem;
  border-top: 0.48rem solid transparent;
  border-bottom: 0.48rem solid transparent;
  border-left: 0.78rem solid currentColor;
}

.lightbox {
  position: fixed;
  z-index: var(--z-modal);
  inset: 0;
  display: grid;
  padding: clamp(1rem, 4vw, 4rem);
  background: rgb(5 5 5 / 88%);
  backdrop-filter: blur(18px);
  place-items: center;
  animation: lightboxFadeIn 280ms ease both;
}

.lightboxFigure {
  display: flex;
  width: 100%;
  height: 100%;
  margin: 0;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: var(--space-xs);
  animation: lightboxScaleIn 280ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.videoLightboxFigure {
  display: flex;
  width: min(92vw, 80rem);
  max-height: calc(100svh - 4rem);
  margin: 0;
  flex-direction: column;
  gap: var(--space-xs);
  animation: lightboxScaleIn 280ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.videoLightboxPlayer {
  display: block;
  width: 100%;
  max-height: calc(100svh - 7rem);
  background: #050505;
  object-fit: contain;
}

.lightboxImage {
  display: block;
  width: auto;
  max-width: 100%;
  height: auto;
  max-height: calc(100% - 3rem);
  object-fit: contain;
}

.lightboxImage[data-wechat-protected-media] {
  width: 100%;
  height: auto;
}

.lightboxCaption {
  width: 100%;
  color: var(--color-text-primary);
  font-size: var(--font-size-caption);
  letter-spacing: 0.14em;
  text-align: left;
}

.lightboxClose {
  position: absolute;
  z-index: 1;
  top: clamp(1rem, 3vw, 2.5rem);
  right: clamp(1rem, 3vw, 2.5rem);
  width: 2.75rem;
  height: 2.75rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: white;
  cursor: pointer;
}

.lightboxClose span::before,
.lightboxClose span::after {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 1.75rem;
  height: 1px;
  background: currentColor;
  content: '';
}

.lightboxClose span::before {
  transform: translate(-50%, -50%) rotate(45deg);
}

.lightboxClose span::after {
  transform: translate(-50%, -50%) rotate(-45deg);
}

@keyframes lightboxFadeIn {
  from {
    opacity: 0;
  }
}

@keyframes lightboxScaleIn {
  from {
    opacity: 0;
    transform: scale(0.975);
  }
}

@media (hover: hover) and (pointer: fine) {
  .diagramFrame:hover .diagram {
    transform: scale(var(--scale-hover));
  }

  .galleryImageButton:hover .galleryImage {
    transform: scale(1.02);
  }

  .videoControl:hover .videoPlayBadge {
    border-color: white;
    background: rgb(5 5 5 / 28%);
    transform: scale(1.04);
  }
}

@media (max-width: 63.9375rem) {
  .section {
    padding-top: clamp(var(--space-m), 6vw, var(--space-l));
  }

  .compactHeading {
    display: block;
    width: min(calc(100% - (var(--page-margin) * 2)), 48rem);
    margin: 0 auto clamp(var(--space-s), 3vw, var(--space-m));
  }

  .desktopHeading {
    display: none;
  }

  .split {
    display: block;
    width: 100%;
    min-height: auto;
  }

  .visualColumn {
    position: static;
    display: block;
    width: min(calc(100% - (var(--page-margin) * 2)), 64rem);
    height: auto;
    margin-inline: auto;
  }

  .narrative {
    width: min(calc(100% - (var(--page-margin) * 2)), 48rem);
    margin-inline: auto;
    padding-block: clamp(2rem, 5vw, var(--space-m))
      clamp(var(--space-m), 7vw, var(--space-l));
    gap: clamp(var(--space-s), 3vw, 2rem);
  }

  .heading,
  .contentBlock,
  .metricCard,
  .dimensionBlock {
    width: 100%;
    margin-left: 0;
  }

  .environmentFrame {
    height: min(75vw, 48rem);
    min-height: 26rem;
    margin-top: clamp(var(--space-m), 6vw, var(--space-l));
  }

  .galleryModule,
  .videoModule {
    width: min(calc(100% - (var(--page-margin) * 2)), 56rem);
  }

  .galleryItem {
    flex-basis: 86%;
  }

  .galleryTrack {
    -webkit-overflow-scrolling: touch;
    scroll-behavior: auto;
    scroll-snap-type: x proximity;
  }

  .galleryModule {
    margin-top: clamp(var(--space-l), 10vw, 6rem);
  }

  .videoModule {
    margin-top: clamp(var(--space-l), 9vw, 6rem);
    margin-bottom: clamp(var(--space-l), 10vw, 6rem);
  }
}

@media (max-width: 47.9375rem) {
  .section {
    padding-top: clamp(2rem, 8vw, var(--space-m));
  }

  .compactHeading {
    margin-bottom: var(--space-s);
  }

  .diagramFrame {
    width: 100vw;
    height: min(40svh, 23rem);
    margin-left: calc(50% - 50vw);
    border-radius: 0;
  }

  .diagram {
    height: 100%;
  }

  .narrative {
    position: relative;
    z-index: var(--z-content);
    margin-top: calc(var(--space-s) * -1);
    padding-block: 2rem var(--space-m);
    gap: var(--space-s);
  }

  .body,
  .metricCard p,
  .dimensionBlock {
    line-height: 1.6;
  }

  .environmentFrame {
    height: 62svh;
    min-height: 30rem;
    margin-top: var(--space-m);
  }

  .environment {
    object-position: center center;
  }

  .galleryModule,
  .videoModule {
    width: 100vw;
  }

  .galleryModule {
    margin-top: clamp(var(--space-m), 12vw, 4rem);
  }

  .galleryTrack {
    gap: var(--space-xs);
    scroll-behavior: auto;
    scroll-snap-type: x proximity;
  }

  .galleryItem {
    flex-basis: 82vw;
  }

  .caption,
  .progressTrack {
    width: calc(100% - (var(--page-margin) * 2));
    margin-inline: auto;
  }

  .caption {
    font-size: max(var(--font-size-caption), 0.75rem);
  }

  .progressTrack {
    margin-top: var(--space-s);
  }

  .videoModule {
    margin-top: clamp(var(--space-m), 12vw, 4rem);
    margin-bottom: clamp(var(--space-m), 14vw, var(--space-l));
  }

  .videoControl {
    width: 100%;
    height: 100%;
  }

  .videoPlayBadge {
    width: 4rem;
    height: 4rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .galleryTrack {
    scroll-behavior: auto;
  }

  .galleryImage,
  .progressValue,
  .videoPlayBadge,
  .videoShade,
  .lightbox,
  .lightboxFigure,
  .videoLightboxFigure {
    transition: none;
    animation: none;
  }
}
